var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',_vm._l((_vm.items),function(toggle,index){return _c('label',{key:index,class:{
      checked: toggle.value === _vm.selected,
      disabled: toggle.disabled,
    }},[_c('input',{attrs:{"type":"radio","name":"viewMode"},domProps:{"value":toggle.value,"checked":toggle.value === _vm.selected},on:{"input":function($event){toggle.disabled ? null : (_vm.selected = toggle)}}}),_c('span',{staticClass:"label"},[_vm._v(" "+_vm._s(toggle.label)+" ")]),(toggle.stat)?_c('span',{staticClass:"rounded-lg px-2 ml-2 leading-tight",class:toggle.value === _vm.selected
          ? 'bg-white text-purple-300'
          : 'bg-purple-300 text-white'},[_vm._v(" "+_vm._s(toggle.stat)+" ")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }